export const omit = (object, ...keys) =>
  filterObject(object, k => !keys.includes(k));

// export const omit = (object, ...keys) => Object.entries(object)
//   .filter(x => !keys.includes(x[0]))
//   .reduce((acc, obj) => {
//     acc[obj[0]] = obj[1];
//     return acc;
//   }, {});

export const filterObject = (object, predicate) =>
  Object.entries(object)
    .filter(x => predicate(x[0], x[1]))
    .reduce((acc, obj) => {
      acc[obj[0]] = obj[1];
      return acc;
    }, {});
